<template>
  <div class="ui grid">
    <div v-if="!testSubmitted" class="row">
      <h1 class="ui huge header">
        {{ $t('choiceSelectionTitle', { name: student.firstName }) }}
      </h1>
    </div>
    <div v-if="!testSubmitted" class="row">
      <table class="ui single line striped selectable table">
        <thead>
          <tr>
            <th class="ten wide">{{ $t('choiceSelectionColumnName') }}</th>
            <th class="two wide center aligned">
              {{ $t('choiceSelectionColumnLike') }}
            </th>
            <th class="two wide center aligned">
              {{ $t('choiceSelectionColumnNeutral') }}
            </th>
            <th class="two wide center aligned">
              {{ $t('choiceSelectionColumnReject') }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="!otherStudents || otherStudents.length == 0">
            <td></td>
            <td colspan="4">{{ $t('choiceSelectionNoStudents') }}</td>
          </tr>
          <tr
            v-else
            v-for="student in otherStudents"
            v-bind:key="student.id"
            :class="rowClass(student.id)"
          >
            <td>{{ student.lastName }}, {{ student.firstName }}</td>
            <td class="center aligned">
              <div class="field">
                <input
                  :name="student.id"
                  type="radio"
                  v-on:change="choice(student.id, 'Like')"
                />
              </div>
            </td>
            <td class="center aligned">
              <div class="field">
                <input
                  :name="student.id"
                  type="radio"
                  v-on:change="choice(student.id, 'Neutral')"
                />
              </div>
            </td>
            <td class="center aligned">
              <div class="field">
                <input
                  :name="student.id"
                  type="radio"
                  v-on:change="choice(student.id, 'Dislike')"
                />
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <div>
        <router-link to="/student/select">
          <sui-button
            :content="$t('choiceSelectionBackButton')"
            negative
            icon="arrow circle left"
          />
        </router-link>
        <sui-button
          :content="$t('choiceSelectionSubmitButton')"
          positive
          icon="thumbs up"
          v-on:click="submit"
        />
        <p v-if="error" class="ui negative message">{{ error }}</p>
      </div>
    </div>
    <div v-if="testSubmitted" class="row">
      <h1 class="ui huge header">
        {{ $t('thankYouTitle', { name: student.firstName }) }}
      </h1>
    </div>
    <div v-if="testSubmitted">
      <p>
        {{ $t('thankYouText') }}
      </p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'TestExecution',
  components: {},
  computed: mapGetters({
    student: 'student',
    otherStudents: 'otherStudents',
    test: 'test',
    testSubmitted: 'testSubmitted',
  }),
  data() {
    return {
      results: {},
      rowErrors: {},
      error: null,
    };
  },
  methods: {
    choice(studentId, action) {
      this.results[studentId] = action;
      delete this.rowErrors[studentId];
    },
    rowClass(id) {
      const result = [];
      if (this.rowErrors[id]) {
        result.push('error');
      }
      return result;
    },
    validate() {
      this.rowErrors = {};
      this.error = '';
      for (let i = 0; i < this.otherStudents.length; i += 1) {
        if (!this.results[this.otherStudents[i].id]) {
          this.rowErrors[this.otherStudents[i].id] = this.$t(
            'choiceSelectionErrorMessageAnswer',
          );
          this.error = this.$t('choiceSelectionErrorMessageChoice');
        }
      }
    },
    submit() {
      this.validate();
      if (Object.keys(this.rowErrors).length === 0) {
        const request = {
          studentId: this.student.id,
          testId: this.test.id,
          Choices: this.results,
        };
        this.$store.dispatch('submitTest', request).then(
          () => {},
          (error) => {
            this.error = error.response.data;
          },
        );
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/tests/TestExecution.vue